import React from 'react';
import { ReactComponent as Star } from 'icons/star.svg';
import Tooltip from 'components/Global/Tooltip';
import BGEye from 'icons/BGeye.svg';
import BGEyeOff from 'icons/BGeyeOff.svg';
import clsx from 'clsx';
import { createSearchParams, useNavigate } from 'react-router-dom';

const DriverReviewItem = ({ reviewData, bgColor, onToggleVisibility, type }) => {
  const navigate = useNavigate();

  const getInitialName = (val) => {
    let initials = '';
    const names = val.trim().split(' ');
    initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names.at(-1).substring(0, 1).toUpperCase();
    }

    return initials;
  };

  const getServices = () => {
    if (reviewData?.order_type_id === 1) {
      if (reviewData?.support_driver) return { name: 'Dengan Supir', value: 'with-driver' };
      return { name: 'Tanpa Supir', value: 'without-driver' };
    }
    if (reviewData?.order_type_id === 2 || reviewData?.order_type_id === 7)
      return { name: 'Airport Transfer', value: 'airport-transfer' };
    if (reviewData?.order_type_id === 8) return { name: 'Car Charter', value: 'car-charter' };
    return { name: '-', value: '-' };
  };

  const handleReviewClick = () => {
    const transactionKey = reviewData?.transaction_key;
    const orderType = getServices()?.value;
    const customerId = reviewData?.customer_id;

    if (transactionKey) {
      navigate({
        pathname: `/${orderType}/detail/${transactionKey}`,
        search: createSearchParams({
          customerId: customerId,
        }).toString(),
      });
    }
  };

  const itemRating = type === 'driver' ? reviewData?.driver_rating : reviewData?.rating;
  const itemComment = type === 'driver' ? reviewData?.review_driver : reviewData?.comment;

  return (
    <div className="driver__review-driver__item">
      <div className="driver__review-driver__header">
        <figure style={{ backgroundColor: bgColor }}>{getInitialName(reviewData?.user?.name ?? '-')}</figure>
        <div>
          <h3>{reviewData?.user?.name ?? '-'}</h3>
          <p>{getServices()?.name}</p>
        </div>
      </div>

      <button className="driver__review-driver__stars" onClick={handleReviewClick}>
        <div>
          {Array.from({ length: Math.floor(itemRating) }, (_, i) => i + 1).map((star, idx) => (
            <Star key={star} color={idx < Math.floor(itemRating) ? '#f1a33a' : '#edebeb'} width={18} height={18} />
          ))}
          {Array.from({ length: 5 - Math.floor(itemRating) }, (_, i) => i + 1).map((star) => (
            <Star key={star} color="#edebeb" width={18} height={18} />
          ))}
        </div>

        <p>{itemRating}/5</p>
      </button>
      <div className={clsx('driver__review-driver__comment', onToggleVisibility && 'with-toggle-button')}>
        <p>{itemComment ?? '-'}</p>
        {onToggleVisibility && (
          <Tooltip content={reviewData.shown ? 'Hide' : 'Show'}>
            <button
              type="button"
              className="driver__review-visibility-btn"
              onClick={() => onToggleVisibility(reviewData)}
              aria-label={reviewData.shown ? 'Hide review' : 'Show review'}
            >
              <img alt={reviewData.shown ? 'Hide review' : 'Show review'} src={reviewData.shown ? BGEye : BGEyeOff} />
            </button>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default DriverReviewItem;
